import { z } from "zod";
import { VARIANTS, variantSchema } from "./table";
/**
 * "Find players" (review 0020, ADR 0035): the player asks for a game, the server keeps them in that
 * game's queue and seats them at a table once one is formed or has a free seat.
 */
export const matchRequestSchema = z.object({
    variant: variantSchema,
    /** The first ask of a search; later asks keep the place in the queue. */
    fresh: z.boolean().default(false),
});
export const matchStatusSchema = z.discriminatedUnion("status", [
    z.object({
        status: z.literal("searching"),
        variant: variantSchema,
        /** Server time the search started; the client shows the wait from it. */
        since: z.number().int().nonnegative(),
        now: z.number().int().nonnegative(),
        /** Players in this game's queue, the asker included. */
        waiting: z.number().int().positive(),
    }),
    z.object({ status: z.literal("matched"), tableId: z.string().min(1) }),
    z.object({ status: z.literal("idle") }),
]);
/** Built from the list of games, so a new game's queue tables read as its own (review 0027 A3). */
const QUEUE_TABLE = new RegExp(`^q\\.(${VARIANTS.join("|")})\\.[A-Za-z0-9-]{8,64}$`);
/** A table the queue formed: its id carries the game, so the table starts with that game's standard settings. */
export function queueTableId(variant, unique) {
    return `q.${variant}.${unique}`;
}
/** The game of a queue table; null for every other table (a channel's, a link's, a local one). */
export function queueVariantOf(tableId) {
    const found = QUEUE_TABLE.exec(tableId);
    return found === null ? null : found[1];
}
//# sourceMappingURL=match.js.map